<template>
  <div>
    <common-dialog ref="dialog" width="1200px" title="工单列表" id-key="UserId" @close-saved="$emit('close-saved')" @closed="onClosed">
      <list ref="list"  disabled :tableType="1" :ProductId="ProductId"></list>
      <div slot="footer">
        <el-button type="primary" @click="saved">保存</el-button>
      </div>
    </common-dialog>
  </div>
</template>  
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "./list";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    ProductId: {
      type: Number,
      default: 0,
    },
    DictionaryId: {
      type: Number,
      default: 0,
    },
    Stage: {
      type: Number,
      default: 0,
    },
    OrderType: {
      type: Number,
      default: 0,
    },
    processList: {
      type: Array,
      default: () => [],
    }

  },
  methods: {
    get_data(o) {
      this.$nextTick(() => {
        console.log('o', o)
        this.$refs.list.$refs.list.query(o)
        this.$refs.list.$refs.list.getData()
      })
    },
    saved() {
      let selectList = this.$refs.list.selectList;
      // 只能选中一条数据
      if (selectList.length !== 1) {
        this.$message({
          message: "只能选中一条工单",
          type: "warning"
        });
        return;
      }
      this.$emit('saved', selectList);
      this.close();
    },
    onClosed() {
      this.$refs.list.onClear();
    }
  }
};
</script>
